<template>
  <v-carousel cycle hide-delimiter-background show-arrows-on-hover height="580">
    <v-carousel-item
      v-for="(item, i) in items"
      :key="i"
      :src="item.src"
      :min-height="minHeight"
      class="white--text"
      gradient="to right, rgba(5, 11, 31, .8), rgba(5, 11, 31, .8)"
    >
      <v-container class="px-4 py-12">
        <v-responsive
          class="d-flex align-center"
          height="100%"
          max-width="700"
          width="100%"
        >
          <h1>MyEduVisa Consutlancy</h1>
          <h2 class="pt-5">
            "Imagine A Better Future.<br />
            Make It Happen"
          </h2>

          <base-body> A one-stop solution for all your visa needs! </base-body>

          <v-btn class="ma-2" outlined rounded color="green accent-4">
            <b> know more >></b>
          </v-btn>
        </v-responsive>
      </v-container>
      <br />
    </v-carousel-item>
  </v-carousel>
</template>

<script>
export default {
  name: "SectionHero",

  provide: {
    theme: { isDark: true },
  },

  computed: {
    minHeight() {
      const height = this.$vuetify.breakpoint.mdAndUp ? "140vh" : "50vh";

      return `calc(${height} - ${this.$vuetify.application.top}px)`;
    },
  },

  data() {
    return {
      items: [
        {
          src: require("@/assets/stVisa.jpg"),
        },
        {
          src: require("@/assets/svisa.jpg"),
        },
      ],
    };
  },
};
</script>
<style scoped>
h1 {
  font-size: 50px;
  padding-top: 100px;
}
h3 {
  font-size: 40px;
}
</style>
